export const setTax = 'setTax'
export const setTaxes = 'setTaxes'
export const setFilterTax = 'setFilterTax'
export const clearFilterTax = 'clearFilterTax'
export const clearFilterTaxes = 'clearFilterTaxes'



// WEBPACK FOOTER //
// ./src/app/pages/taxes/vuex/mutations-types.js